import { DateRangeType } from '@fluentui/date-time-utilities/lib/dateValues/dateValues';
import { logUsage } from 'owa-analytics';
import { assertNever } from 'owa-assert';
import { ControlIcons } from 'owa-control-icons';
import { DisplayOption, FilterableMenuItem, FilterableMenuItemArgs } from 'owa-filterable-menu';
import loc, { format } from 'owa-localize';
import { goToNextDayText } from 'owa-locstrings/lib/strings/gotonextdaytext.locstring.json';
import { goToPreviousDayText } from 'owa-locstrings/lib/strings/gotopreviousdaytext.locstring.json';
import {
    getSurfaceStore,
    getNextSurfaceDateRangeString,
    getPreviousSurfaceDateRangeString,
} from 'owa-calendar-surface-surface-store';
import {
    goToNextSurfaceDateRange,
    goToPreviousSurfaceDateRange,
} from 'owa-calendar-module-commanding';
import {
    goToPreviousWeekStringText,
    goToNextWeekStringText,
    goToPreviousMonthText,
    goToNextMonthStringText,
} from 'owa-calendar-shared-strings/lib/strings/calendarSurfaceCommandBar.locstring.json';

export function getSurfaceNavigationMenuItems() {
    const currentDateRangeType = getSurfaceStore().dateRangeType;

    let currentViewPreviousLabel: string = '';
    let currentViewNextLabel: string = '';
    switch (currentDateRangeType) {
        case DateRangeType.Day:
            currentViewPreviousLabel = loc(goToPreviousDayText);
            currentViewNextLabel = loc(goToNextDayText);
            break;
        case DateRangeType.WorkWeek:
            currentViewPreviousLabel = loc(goToPreviousWeekStringText);
            currentViewNextLabel = loc(goToNextWeekStringText);
            break;
        case DateRangeType.Week:
            currentViewPreviousLabel = loc(goToPreviousWeekStringText);
            currentViewNextLabel = loc(goToNextWeekStringText);
            break;
        case DateRangeType.Month:
            currentViewPreviousLabel = loc(goToPreviousMonthText);
            currentViewNextLabel = loc(goToNextMonthStringText);
            break;
        default:
            assertNever(currentDateRangeType);
    }

    const previousLabel = format(
        currentViewPreviousLabel,
        '\n' + getPreviousSurfaceDateRangeString()
    );
    const nextLabel = format(currentViewNextLabel, '\n' + getNextSurfaceDateRangeString());

    const onPrevious = () => {
        logUsage('SurfaceCommandBar_Previous', {
            currentDateRangeType: currentDateRangeType,
        });
        goToPreviousSurfaceDateRange();
    };

    const onNext = () => {
        logUsage('SurfaceCommandBar_Next', {
            currentDateRangeType: currentDateRangeType,
        });
        goToNextSurfaceDateRange();
    };

    const isMonthDateRange = currentDateRangeType === DateRangeType.Month;

    return [
        new FilterableMenuItem({
            [FilterableMenuItemArgs.icon]: isMonthDateRange ? ControlIcons.Up : ControlIcons.Back,
            [FilterableMenuItemArgs.onClick]: onPrevious,
            [FilterableMenuItemArgs.displayOption]: DisplayOption.Left,
            [FilterableMenuItemArgs.ariaLabel]: previousLabel,
            [FilterableMenuItemArgs.title]: previousLabel,
            [FilterableMenuItemArgs.className]: 'flipForRtl',
        }),
        new FilterableMenuItem({
            [FilterableMenuItemArgs.icon]: isMonthDateRange
                ? ControlIcons.Down
                : ControlIcons.Forward,
            [FilterableMenuItemArgs.onClick]: onNext,
            [FilterableMenuItemArgs.displayOption]: DisplayOption.Left,
            [FilterableMenuItemArgs.ariaLabel]: nextLabel,
            [FilterableMenuItemArgs.title]: nextLabel,
            [FilterableMenuItemArgs.className]: 'flipForRtl',
        }),
    ];
}
